import { DrawerTheme, SternumTheme } from '@sternum/ui';

import { Colors, Shadows } from '../constants';

export function SBOMDarkDrawerTheme(theme: SternumTheme): Partial<DrawerTheme.DrawerTheme> {
  return {
    background: Colors.Darkest,
    textColor: theme.textColor,
    openShadow: Shadows.DrawerDarkMode,
  };
}
